<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 客渠管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>渠道信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-input v-model="query.name" placeholder="名称" class="handle-input mr10" style="width:160px;"></el-input>
				<el-input v-model="query.contact" placeholder="联系人" class="handle-input mr10" style="width:160px;"></el-input>
				<el-input v-model="query.tel" placeholder="联系电话" class="handle-input mr10" style="width:160px;"></el-input>
				<el-select v-model="query.channelType" placeholder="请选择渠道类型" style="width:160px;">
					<el-option key="" label="请选择渠道类型" value=""></el-option>
					<el-option v-for="item in channelTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.quality" placeholder="请选择渠道质量" style="width:160px;">
					<el-option key="" label="请选择渠道质量" value=""></el-option>
					<el-option v-for="item in qualityKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.provideInventory" placeholder="请选择是否有提供库存">
					<el-option key="" label="请选择是否有提供库存" value=""></el-option>
					<el-option key="true" label="有提供" value="true"></el-option>
					<el-option key="false" label="未提供" value="false"></el-option>
				</el-select>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="name" label="名称" width="260" ></el-table-column>
				<el-table-column prop="contact" label="联系人" width="80"></el-table-column>
				<el-table-column prop="tel" label="联系电话" width="130"></el-table-column>
				<el-table-column prop="channelType" label="渠道类型" :formatter="channelTypeFormat" width="80"></el-table-column>
				<el-table-column prop="quality" label="质量" :formatter="qualityFormat" width="70"></el-table-column>
				<el-table-column prop="accountBalance" label="挂账余额" width="100"></el-table-column>
				<el-table-column prop="provideInventory" label="库存" width="80">
					<template slot-scope="scope">
						{{scope.row.provideInventory?"有":"未"}}提供
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注"></el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="160" ></el-table-column>
                <el-table-column label="操作" width="210" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>&nbsp;
						<router-link  :to="{path:'/account-record',query:{id:scope.row.id, type:0}}" v-if="controll['account-record']"><el-button
                            type="text"
                            icon="el-icon-link"
							v-if="controll['account-record']"
                        >资金记录</el-button></router-link>&nbsp;
                        <el-button
                            type="text"
                            icon="el-icon-edit-outline"
                            @click="handleRefund(scope.$index, scope.row)"
							v-if="controll['refund'] && scope.row.accountBalance>0"
                        >退款</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<!-- <el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>-->
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="退款申请" :visible.sync="refundVisible" width="40%">
			<el-form ref="refund" :model="refund" label-width="120px" :rules="refundRules">
				<el-form-item label="名称" prop="name">
					{{refund.name}}
				</el-form-item>
				<el-form-item label="余额" prop="accountBalance">
					{{refund.accountBalance}}
				</el-form-item>
				<el-form-item label="退款金额" prop="amount">
					<el-input v-model="refund.amount"></el-input>
				</el-form-item>
				<el-form-item label="退款申请说明" prop="remark">
					<el-input type=textarea :rows=5 v-model="refund.remark"> </el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="refundVisible = false">取 消</el-button>
				<el-button type="primary" @click="refundSave" v-prevent-re-click>申 请</el-button>
			</span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-tabs v-model="activeName" type="card">
					<el-tab-pane label="基本信息" name="baseTab">
						<el-form-item label="名称" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
						<el-form-item label="联系人" prop="contact">
							<el-input v-model="form.contact" v-if="!form.contactHistorys"></el-input>
							<el-input v-model="form.contact" v-if="form.contactHistorys" style="width:85%"></el-input>
							<el-button
								type="text"
								style="margin-left:5px;"
								@click="contactHistoryVisible = true"
								v-if="form.contactHistorys"
							>历史联系人</el-button>
						</el-form-item>
						<el-form-item label="联系电话" prop="tel">
							<el-input v-model="form.tel"></el-input>
						</el-form-item>
						<el-row>
							<el-col :span="12">
								<el-form-item label="QQ" prop="qq">
									<el-input v-model="form.qq"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="微信" prop="wechat">
									<el-input v-model="form.wechat"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="地址" prop="address">
							<el-input v-model="form.address"></el-input>
						</el-form-item>
						<el-row>
							<el-col :span="12">
								<el-form-item label="渠道类型" prop="channelType">
									<el-select v-model="form.channelType" placeholder="请选择渠道类型">
										<el-option key="" label="请选择渠道类型" value=""></el-option>
										<el-option v-for="item in channelTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="渠道质量" prop="quality">
									<el-select v-model="form.quality" placeholder="请选择渠道质量">
										<el-option key="" label="请选择渠道质量" value=""></el-option>
										<el-option v-for="item in qualityKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
						<el-form-item label="提供库存信息" prop="provideInventory"  v-if="form.id!=null">
							<el-select v-model="form.provideInventory" placeholder="请选择是否提供库存信息">
								<el-option key="" label="请选择是否提供库存信息" value=""></el-option>
								<el-option :key="true" label="有提供" :value="true"></el-option>
								<el-option :key="false" label="未提供" :value="false"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="备注">
							<el-input type=textarea :rows=3 v-model="form.remark"> </el-input>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="经营品牌" name="brandTab">
						<el-checkbox-group v-model="form.brandIds">
						<div style="border:1px solid #e1e1e1;padding:10px;height:415px;overflow-y:auto">
							<el-checkbox v-for="item in manufacturerKV" :label="item.key" style="width:80%;margin:8px;">
							{{item.value}}</el-checkbox>
						</div>			
						</el-checkbox-group>
					</el-tab-pane>
				</el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
			
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="历史联系人" :visible.sync="contactHistoryVisible" width="35%">
			<el-table
                :data="this.form.contactHistorys"
                border
                class="table"
                ref="contactHistorysTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
				max-height="360px"
            >
				<el-table-column prop="name" label="联系人" width="120px"></el-table-column>
				<el-table-column prop="contactType" label="类型" :formatter="contactTypeFormatter" width="100px"></el-table-column>
				<el-table-column prop="content" label="号码"></el-table-column>
				<el-table-column prop="createTime" label="变更时间" width="160px"></el-table-column>
            </el-table>
		</el-dialog>
    </div>
</template>

<script>
import bus from '../../common/bus';
import { getControll } from '../../../utils/controlls';
import { fetchChannelData, saveChannel, deleteChannel, getChannel, getEnumValueKV, saveChannelAccountRecord, getManufacturerKV } from '../../../api/index';
export default {
    name: 'channel',
    data() {
        return {
            query: {
                shortName: '',
                brand: '',
                pageNum: 1,
                pageSize: 10
            },
			channelTypeKV:[],
			qualityKV:[],
			channelTypeCode:1002,
			qualityCode:1010,
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			title:"",
			rules: {
                name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
                contact: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
				tel: [{ required: true, message: '电话不能为空', trigger: 'blur' }],
				address: [{ required: true, message: '地址不能为空', trigger: 'blur' }],
				channelType: [{ required: true, message: '请选择渠道类型', trigger: 'blur' }]
            },
			refundRules: {
				amount :[{ required: true, message: '请输入金额', trigger: 'blur' }],
			},
			refundVisible:false,
			refund:{},
			controll:{},
			manufacturerKV:[],
			activeName:"baseTab",
			contactHistoryVisible:false,
			contactTypeMapping:{"1":"电话","2":"QQ","3":"微信","4":"邮箱"}
        };
    },
    created() {
		this.controll = getControll('channel');
		bus.$on('channel', msg => {
            for (var key in msg) {
				this.$set(this.query, key, msg[key]);
			}
			this.getData();
        });
		this.getChannelTypeKV();
		this.getChannelQualityKV();
		this.getBrandKV();
        this.getData();
    },
    methods: {
		contactTypeFormatter(row, column, cellValue) {
			return this.contactTypeMapping[cellValue];
		},
		getBrandKV() {
			getManufacturerKV().then(res => {
				if (res.code == 0 ) {
					this.manufacturerKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//获取渠道类型
		getChannelTypeKV() {
			getEnumValueKV(this.channelTypeCode).then(res => {
				if (res.code == 0 ) {
					this.channelTypeKV = res.data;
				} else {
					this.$message.error("获取配置信息失败！" + res.message);
				}
			});
		},
		//获取渠道类型
		getChannelQualityKV() {
			getEnumValueKV(this.qualityCode).then(res => {
				if (res.code == 0 ) {
					this.qualityKV = res.data;
				} else {
					this.$message.error("获取配置信息失败！" + res.message);
				}
			});
		},
		//渠道类型格式化
		channelTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.channelTypeKV.length; i++) {
				if (this.channelTypeKV[i].key === cellValue){
					return this.channelTypeKV[i].value;
				}
			}
			return cellValue;
		},
		//渠道质量格式化
		qualityFormat(row, column, cellValue) {
			for (var i = 0; i < this.qualityKV.length; i++) {
				if (this.qualityKV[i].key === cellValue){
					return this.qualityKV[i].value;
				}
			}
			return cellValue;
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchChannelData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChannel([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteChannel(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {"brandIds":[]};
			this.title = "添加新纪录";
			this.isDisabled = false;
			this.editVisible = true;
			this.activeName = "baseTab";
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
            //this.form = row;
			this.title = "编辑";
			this.isDisabled = true;
			getChannel(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.activeName = "baseTab";
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					if (this.form.provideInventory == "") {
						this.form.provideInventory = false;
					}
					saveChannel(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
		handleRefund(index, row) {
			getChannel(row.id).then(res => {
				if (res.code == 0) {
					this.refund = res.data;
					this.refund.remark = "";
					this.refundVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
		},
		refundSave() {
			this.$refs.refund.validate(valid => {
				if (valid){
					let data = {};
					data["accountCompanyId"] = this.refund.id;
					data["amount"] = this.refund.amount;
					data["remark"] = this.refund.remark;
					saveChannelAccountRecord(data).then(res => {
						if (res.code == 0) {
							this.$message.success('退款申请提交成功！');
							this.refundVisible = false;
							this.getData();
						} else {
							this.$message.error(res.message);
						}
					}); 
				} else {
					this.$message.error('信息填写不完整！');
				}
            });
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
